<template src="./index.html"></template>

<script>
import genCore from '../index';
import componentsMixin from './componentsMixin';
export default {
    mixins: [genCore(true), componentsMixin]
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import './index.scss';
</style>
